export default __webpack_public_path__ + "static/img-finish-products-498fef2c052ee2021111032759714910.webp";